import React, {useEffect, useState} from 'react';
import {callApi, callEmptyParamsApi} from "../../../connection/ClientApi";
import ScrollableTitleImage from "components/imageList/ScrollableTitleImage";
import {IsLP_MP, IsSP, IsT} from "my-styles/media/media";
import EmptyBox from "components/emptyBox/EmptyBox";
import RewardItem from "./RewardItem";
import Space from "components/space/Space";
import Urls from "../../../connection/Urls";
import messages from "res/messages/farsi";
import {Divider} from "@material-ui/core";
import queryString from "query-string";
import TitleAddHeader from "../address/TitleAddHeader";

import ICReward from "res/images/rewards.png";

export const REWARD_TYPES = {
    DISCOUNT: 0,
    BON: 1
}

export default function Rewards(props) {

    const urlParams = queryString.parse(props.location.search)

    const [isCancelled, setIsCancelled] = useState(false)
    const [rewardHeader, setRewardHeader] = useState()
    const [currentRewardHeader, setCurrentRewardHeader] = useState(undefined)
    const [rewards, setRewards] = useState()

    function requestRewardHeader() {
        callEmptyParamsApi(Urls.getUnusedRewardsTypes, (data) => {
            if (isCancelled) return

            if (data && data.list) {
                let type = data.list[0].type
                let currentRewardHeader = data.list[0]
                if (urlParams) {
                    for (let item of data.list) {
                        if (item.type === parseInt(urlParams.t)) {
                            type = item.type
                            currentRewardHeader = item
                            break
                        }
                    }
                }
                setCurrentRewardHeader(currentRewardHeader)
                setRewardHeader(data.list)
                requestRewardLines(type)
            } else {
                setCurrentRewardHeader(undefined)
                setRewardHeader([])
                setRewards([])
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestRewardLines(type) {
        let params = new FormData()
        params.append("reward_type", type)
        callApi(Urls.getUnusedRewards, params, (data) => {
                if (data && data.list) {
                    setRewards(data.list)
                } else {
                    setRewards([])
                }
            }, () => {
                props.onAlert(messages.responseCodeIsNot200)
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            }
        )
    }

    useEffect(() => {
        requestRewardHeader()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<div className="hInLPT_vInFMS wInLPT100_wInFMS95 paddingTopInTPMS">
        <div className="marginLeftRightSmall wInLP60_wInT50_wInFMS100">
            <div className="marginTopBottomSmall">
                <TitleAddHeader
                    hideicon={"true"}
                    title={messages.myRewards}/>
            </div>
            {(rewardHeader && rewardHeader.length > 0) ?
                <div>
                    <ScrollableTitleImage
                        itemWidth={"10em"}
                        showSelectedItemArrow={true}
                        itemsPerView={IsLP_MP() ? 5 : IsSP() ? 4 : IsT() ? 3 : 4}
                        items={
                            rewardHeader.map((header) => {
                                const onRewardClicked = () => {
                                    requestRewardLines(header.type)
                                    setCurrentRewardHeader(header)
                                }
                                return {
                                    badgenumber: header.count,
                                    title: header.name,
                                    image: header.image,
                                    selected: header.type === currentRewardHeader.type,
                                    onClick: onRewardClicked
                                }
                            })
                        }/>
                    <Space height={"1em"}/>
                    <Divider/>
                    <Space/>
                    {currentRewardHeader && rewards && rewards.length > 0 ?
                        <div className="wInP50_wInTFM100">
                            {rewards.map((reward, index) => {
                                return <RewardItem key={index} {...props} reward={reward}/>
                            })}
                        </div> :
                        <div>
                            <Space/>
                            <EmptyBox message={messages.list + currentRewardHeader.name + messages.isEmpty}/>
                        </div>
                    }
                </div> :
                <EmptyBox message={messages.rewardListEmpty}/>
            }

        </div>
        <div className="marginTopBottomMedium showInLPT_hideInFMS wInLP40_wInT50_wInFMS100">
            <img className="fullWidth" src={ICReward} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
        </div>
    </div>)

}